/**
 * What the app says for each error code pohoda-send answers with. Pure (no client),
 * so the public POHODA guide lists the very same texts in its troubleshooting table.
 */
export const POHODA_ERROR_MESSAGES: Record<string, { cs: string; en: string }> = {
  not_configured: {
    cs: "Napojení na POHODU není nastavené.",
    en: "The POHODA connection is not set up.",
  },
  no_ico: {
    cs: "Chybí IČO účetní jednotky (v napojení nebo v nastavení firmy).",
    en: "The accounting unit's IČO is missing (in the connection or company settings).",
  },
  mserver_unreachable: {
    cs: "mServer není z internetu dostupný. POHODA na počítači v kanceláři obvykle z internetu vidět není – použijte ZIP, nebo zpřístupněte mServer přes HTTPS (viz nápověda).",
    en: "mServer cannot be reached from the internet. POHODA on an office PC usually isn't – use the ZIP, or expose mServer over HTTPS (see help).",
  },
  mserver_timeout: {
    cs: "mServer neodpověděl do 25 s. Zkuste to znovu; co už POHODA má, se podruhé nepošle.",
    en: "mServer did not answer within 25 s. Try again; what POHODA already has is not sent twice.",
  },
  timeout: {
    cs: "mServer nestihl požadavek zpracovat. Zkuste to znovu.",
    en: "mServer could not process the request in time. Try again.",
  },
  auth: {
    cs: "POHODA odmítla jméno nebo heslo.",
    en: "POHODA rejected the user name or password.",
  },
  forbidden: {
    cs: "Uživatel nemá v POHODĚ právo otevřít účetní jednotku nebo XML komunikaci.",
    en: "The user may not open the accounting unit or use XML communication in POHODA.",
  },
  not_found: {
    cs: "Na adrese neběží mServer (404). Zkontrolujte adresu a port.",
    en: "No mServer at this address (404). Check the address and port.",
  },
  not_mserver: {
    cs: "Adresa neodpovídá jako POHODA mServer.",
    en: "The address does not answer like a POHODA mServer.",
  },
  redirect: {
    cs: "mServer přesměrovává – zadejte přímou adresu.",
    en: "mServer redirects – enter its direct address.",
  },
  url_not_https: {
    cs: "Adresa musí začínat https://.",
    en: "The address must start with https://.",
  },
  url_blocked_host: {
    cs: "Adresa míří do vnitřní sítě (localhost, 10.x, 192.168.x…). Zettl volá jen veřejné adresy.",
    en: "The address points into a private network (localhost, 10.x, 192.168.x…). Zettl only calls public addresses.",
  },
  url_not_resolvable: {
    cs: "Název serveru nejde přeložit (DNS).",
    en: "The server name does not resolve (DNS).",
  },
  url_invalid: { cs: "Neplatná adresa.", en: "Invalid address." },
  url_credentials_in_url: {
    cs: "Jméno a heslo nepatří do adresy, vyplňte je do polí.",
    en: "Put the user name and password in their fields, not in the address.",
  },
  url_query_or_fragment: {
    cs: "Adresa nesmí obsahovat ? ani #.",
    en: "The address must not contain ? or #.",
  },
  username_invalid: {
    cs: "Neplatné jméno uživatele.",
    en: "Invalid user name.",
  },
  password_invalid: {
    cs: "Heslo obsahuje znaky, které POHODA nepřijme.",
    en: "The password has characters POHODA does not accept.",
  },
  password_required: { cs: "Zadejte heslo.", en: "Enter the password." },
  ico_invalid: { cs: "IČO musí být číslo.", en: "IČO must be a number." },
  admin_only: {
    cs: "Napojení může měnit jen vlastník nebo administrátor firmy.",
    en: "Only the company's owner or an admin can change the connection.",
  },
  encryption_not_configured: {
    cs: "Šifrování hesla není na serveru nastavené.",
    en: "Password encryption is not configured on the server.",
  },
  rate_limited: {
    cs: "Příliš mnoho pokusů, zkuste to za chvíli.",
    en: "Too many attempts, try again shortly.",
  },
};

/** User-facing text for an error code from pohoda-send. */
export function pohodaErrorText(code: string, language: string): string {
  const m = POHODA_ERROR_MESSAGES[code];
  if (m) return language === "cs" ? m.cs : m.en;
  return language === "cs" ? `Odeslání selhalo (${code}).` : `Sending failed (${code}).`;
}
